"use client";
import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useState } from "react";
const NumericAndDotsPaginator = /*#__PURE__*/ lazy(()=>import("./NumericAndDotsPaginator.js").then((module)=>({
            default: module.NumericAndDotsPaginator
        })));
const ArrowsPaginator = /*#__PURE__*/ lazy(()=>import("./ArrowsPaginator.js").then((module)=>({
            default: module.ArrowsPaginator
        })));
const SliderPaginator = /*#__PURE__*/ lazy(()=>import("./SliderPaginator.js").then((module)=>({
            default: module.SliderPaginator
        })));
const PagesPaginator = /*#__PURE__*/ lazy(()=>import("./PagesPaginator.js").then((module)=>({
            default: module.PagesPaginator
        })));
const BannerPaginator = /*#__PURE__*/ lazy(()=>import("./BannerPaginator.js").then((module)=>({
            default: module.BannerPaginator
        })));
const CarrouselPaginator = /*#__PURE__*/ lazy(()=>import("./CarrouselPaginator.js").then((module)=>({
            default: module.CarrouselPaginator
        })));
const Paginator = ({ currentPage, defaultPage = 1, totalPages: rawTotalPages, onPageChange, ...otherProps })=>{
    const [page, setPage] = useState(currentPage ?? defaultPage);
    if (rawTotalPages <= 0) return null;
    if (currentPage && !onPageChange) console.error('Warning: You must provide an onPageChange function to the Paginator when using the currentPage prop');
    const totalPages = Math.ceil(rawTotalPages);
    const isFirstPage = 1 === page;
    const isLastPage = page === totalPages;
    const pageToDisplay = currentPage ?? page;
    const goToPage = (newPage)=>{
        if (pageToDisplay < 1 || pageToDisplay > totalPages) return;
        setPage(newPage);
        onPageChange?.(newPage);
    };
    if ('arrows' === otherProps.variant) return /*#__PURE__*/ jsx(Suspense, {
        children: /*#__PURE__*/ jsx(ArrowsPaginator, {
            currentPage: pageToDisplay,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage,
            totalPages: totalPages,
            onPageChange: goToPage,
            ...otherProps
        })
    });
    if ('slider' === otherProps.variant) return /*#__PURE__*/ jsx(Suspense, {
        children: /*#__PURE__*/ jsx(SliderPaginator, {
            currentPage: pageToDisplay,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage,
            totalPages: totalPages,
            onPageChange: goToPage,
            ...otherProps
        })
    });
    if ('pages' === otherProps.variant) return /*#__PURE__*/ jsx(Suspense, {
        children: /*#__PURE__*/ jsx(PagesPaginator, {
            currentPage: pageToDisplay,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage,
            totalPages: totalPages,
            onPageChange: goToPage,
            ...otherProps
        })
    });
    if ('banner' === otherProps.variant) return /*#__PURE__*/ jsx(Suspense, {
        children: /*#__PURE__*/ jsx(BannerPaginator, {
            currentPage: pageToDisplay,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage,
            totalPages: totalPages,
            onPageChange: goToPage,
            ...otherProps
        })
    });
    if ('carrousel' === otherProps.variant) return /*#__PURE__*/ jsx(Suspense, {
        children: /*#__PURE__*/ jsx(CarrouselPaginator, {
            currentPage: pageToDisplay,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage,
            totalPages: totalPages,
            onPageChange: goToPage,
            ...otherProps
        })
    });
    return /*#__PURE__*/ jsx(Suspense, {
        children: /*#__PURE__*/ jsx(NumericAndDotsPaginator, {
            currentPage: pageToDisplay,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage,
            totalPages: totalPages,
            onPageChange: goToPage,
            ...otherProps
        })
    });
};
export { Paginator };
